






























































































import Vue from 'vue'
import bus from '../model/bus'
import EngramFilter from './EngramFilter.vue'

export default Vue.extend({
    name: 'ItemSet',
    components: { EngramFilter },
    data() {
        return {
            bus,
            selected: null,
        }
    },
    created() {},
    computed: {
        manager() {
            return this.selected.EntryManager
        },
    },
    methods: {
        add(item) {
            try {
                bus.game.addEngramToSet(item, this.selected)
            } catch (error) {
                this.$bvToast.toast(`${this.selected.label} already exists!`, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                })
            }
        },
        addAll() {
            bus.game.EngramManager.filtered.forEach(item => {
                this.add(item)
            })
        },
        remove(item) {
            if (confirm('Are you sure?')) {
                this.manager.remove(item)
            }
        },
        removeAll() {
            if (confirm('Are you sure?')) {
                this.manager.clear()
            }
        },
        setWeight() {
            const value = prompt('Please input the Weight', '1')
            if (value !== null) {
                this.manager.list.forEach(item => {
                    item.EntryWeight = parseInt(value)
                })
            }
        },
        setQuantity() {
            const value = prompt('Please input the Amount', '1')
            if (value !== null) {
                this.manager.list.forEach(item => {
                    item.quantity = parseInt(value)
                })
            }
        },
        setChance() {
            const value = prompt('Please input the Chance', '0.5')
            if (value !== null) {
                this.manager.list.forEach(item => {
                    if (item.canBeBluePrint) {
                        item.ChanceToBeBlueprintOverride = parseFloat(value)
                    }
                })
            }
        },
        addSet() {
            const now = new Date()
            const set = bus.game.ItemSetManager.make(now.toISOString())
            set.label = 'ItemSet 1'
            bus.game.ItemSetManager.add(set)
            this.selected = set
        },
        changeName() {
            if (this.selected) {
                const name = prompt('Please input the name', this.selected.label)
                if (name) {
                    this.selected.label = name
                }
            }
        },
        removeSet() {
            if (this.selected) {
                if (confirm('Are you sure?')) {
                    bus.game.ItemSetManager.remove(this.selected)
                    this.selected = null
                }
            }
        },
    },
})
